import { PortalMount } from "components/index";
import { UI_ACTION_PORTAL_ID } from "utils/index";

// Forward remaining props (onClick, ref, aria-*, data-state) so HeaderPortal
// works as a Radix `asChild` trigger, e.g. inside SheetTrigger.
export default function HeaderPortal({ children, className, ...props }) {
    return <PortalMount to={UI_ACTION_PORTAL_ID} className={className} {...props}>{children}</PortalMount>;
}